var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 11.667H7.01725C7.79233 11.667 8.17987 11.667 8.28311 11.9004C8.38634 12.1339 8.12263 12.4139 7.59522 12.974L4.56377 16.1933C4.03636 16.7534 3.77265 17.0334 3.87588 17.2669C3.97912 17.5003 4.36666 17.5003 5.14174 17.5003H8.33301",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 7.5L5.08765 3.58773C5.41288 2.86258 5.57549 2.5 5.83301 2.5C6.09052 2.5 6.25313 2.86258 6.57837 3.58773L8.33301 7.5",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 16.6673V3.33398M14.5833 16.6673C13.9998 16.6673 12.9096 15.0054 12.5 14.584M14.5833 16.6673C15.1668 16.6673 16.2571 15.0054 16.6667 14.584",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscending);
export default __webpack_public_path__ + "static/media/ascending.50c6d0679ce6d059b17d85af2ffd6486.svg";
export { ForwardRef as ReactComponent };